(function () {
  var toggle = document.getElementById('searchToggle');
  var bar = document.getElementById('searchBar');
  var input = bar ? bar.querySelector('input[type="search"]') : null;

  if (toggle && bar) {
    toggle.addEventListener('click', function () {
      var open = bar.classList.toggle('open');
      if (open && input) {
        setTimeout(function () { input.focus(); }, 50);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bar.classList.contains('open')) {
        bar.classList.remove('open');
      }
    });
  }
})();


/* 首页评论徽章：星级数字 + 5 星 + (评论数)，>=1000 用 k；彻底移除 Judge.me 默认 "See all reviews" */
(function () {
  function fmtCount(n) {
    if (n >= 1000) {
      var k = n / 1000;
      var s = (Math.round(k * 10) / 10).toFixed(1);
      if (s.slice(-2) === '.0') s = s.slice(0, -2);
      return s + 'k';
    }
    return String(n);
  }

  function render(badge) {
    if (badge.querySelector('.pc-rating')) return;
    var prev = badge.querySelector('.jdgm-prev-badge');
    if (!prev) return;
    var ratingStr = prev.getAttribute('data-average-rating');
    var countStr = prev.getAttribute('data-number-of-reviews');
    if (!ratingStr || ratingStr === '0.00') return;
    var rating = parseFloat(ratingStr);
    var count = parseInt(countStr || '0', 10);
    if (isNaN(rating) || count <= 0) return;
    var r = (Math.round(rating * 10) / 10).toFixed(1);
    if (r.slice(-2) === '.0') r = r.slice(0, -2);
    // 移除 Judge.me 标识，防止其 JS 二次渲染把 "See all reviews" 加回来
    badge.removeAttribute('data-id');
    badge.classList.remove('jdgm-widget', 'jdgm-preview-badge');
    badge.classList.add('pc-badge');
    // 清空并重建：星级数字 + 5 星 + (评论数)
    badge.innerHTML = '';
    var ratingEl = document.createElement('span');
    ratingEl.className = 'pc-rating';
    ratingEl.textContent = r;
    badge.appendChild(ratingEl);
    var starsEl = document.createElement('span');
    starsEl.className = 'pc-stars';
    starsEl.textContent = '★★★★★';
    badge.appendChild(starsEl);
    var countEl = document.createElement('span');
    countEl.className = 'pc-count';
    countEl.textContent = '(' + fmtCount(count) + ')';
    badge.appendChild(countEl);
  }

  function run() {
    var badges = document.querySelectorAll('.jdgm-preview-badge');
    for (var i = 0; i < badges.length; i++) render(badges[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 2000);
  setTimeout(run, 4000);
})();


/* ===== 产品详情页：图集 + 变体色块 + 数量 + 特性卡片 ===== */
(function () {
  var pdp = document.querySelector('.pdp');
  if (!pdp) return;

  /* 图集：缩略图 + 左右箭头 */
  var main = pdp.querySelector('.pdp-main img');
  var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('.pdp-thumb'));
  var prev = pdp.querySelector('.gal-arrow.prev');
  var next = pdp.querySelector('.gal-arrow.next');
  if (main && thumbs.length) {
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      var full = thumbs[idx].getAttribute('data-full');
      if (full) main.src = full;
      thumbs.forEach(function (t, k) { t.classList.toggle('active', k === idx); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  }

  /* 变体色块 */
  var idInput = pdp.querySelector('.pdp-variant-id');
  var label = pdp.querySelector('.pdp-swatch-label');
  var swatches = Array.prototype.slice.call(pdp.querySelectorAll('.swatch'));
  var mainPrice = pdp.querySelector('.pdp-price .now');
  var mainWas = pdp.querySelector('.pdp-price .was');
  var mainOff = pdp.querySelector('.pdp-price .off');
  var stickyPrice = document.querySelector('#pdpStickyBar .pdp-sticky-price .now');
  var stickyWas = document.querySelector('#pdpStickyBar .pdp-sticky-price .was');
  if (idInput && swatches.length) {
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        idInput.value = s.getAttribute('data-id');
        if (label) label.textContent = s.getAttribute('data-title');
        swatches.forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        // 更新价格与划线价
        var price = s.getAttribute('data-price');
        var compare = s.getAttribute('data-compare');
        var discount = s.getAttribute('data-discount');
        if (mainPrice) mainPrice.textContent = price || '';
        if (mainWas) {
          if (compare) { mainWas.textContent = compare; mainWas.style.display = ''; }
          else { mainWas.style.display = 'none'; }
        }
        if (mainOff) {
          if (discount && discount !== '0') { mainOff.textContent = 'Save ' + discount + '%'; mainOff.style.display = ''; }
          else { mainOff.style.display = 'none'; }
        }
        if (stickyPrice) stickyPrice.textContent = price || '';
        if (stickyWas) {
          if (compare) { stickyWas.textContent = compare; stickyWas.style.display = ''; }
          else { stickyWas.style.display = 'none'; }
        }
      });
    });
  }

  /* 数量步进 */
  var qtyInput = pdp.querySelector('.qty-input');
  var qtyBtns = Array.prototype.slice.call(pdp.querySelectorAll('.qty-btn'));
  if (qtyInput && qtyBtns.length) {
    qtyBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10) || 0;
        var v = (parseInt(qtyInput.value, 10) || 1) + step;
        if (v < 1) v = 1;
        qtyInput.value = v;
      });
    });
  }

  /* 解析描述 <ul><li> 为卖点（标题 + 详情），同时填充变体下方 5 点描述与特性卡片 */
  var grid = document.getElementById('pdpFeaturesGrid');
  var bullets = document.getElementById('pdpBullets');
  var raw = document.querySelector('.pdp-desc-raw');
  if (raw) {
    var ICONS = {
      dual: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
      night: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
      tool: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
      thermo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>',
      eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
      camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>',
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
    };
    function pickIcon(text) {
      var t = text.toLowerCase();
      if (/temperature|humidity|climate|thermometer|hygrometer/.test(t)) return ICONS.thermo;
      if (/night|darkness|color night/.test(t)) return ICONS.night;
      if (/install|setup|peel|stick|bluetooth|mount|wiring/.test(t)) return ICONS.tool;
      if (/detect|motion|person|vehicle|pet|glass|alert/.test(t)) return ICONS.eye;
      if (/record|storage|sd card|cloud|24\/7/.test(t)) return ICONS.shield;
      if (/indoor and outdoor|dual|both indoor|two view|one lens/.test(t)) return ICONS.dual;
      if (/camera|video/.test(t)) return ICONS.camera;
      return ICONS.check;
    }
    function splitText(text) {
      var i = text.indexOf(' - ');
      if (i > 0) return [text.slice(0, i).trim(), text.slice(i + 3).trim()];
      i = text.indexOf(': ');
      if (i > 0) return [text.slice(0, i).trim(), text.slice(i + 2).trim()];
      return [text.trim(), ''];
    }

    var items = Array.prototype.slice.call(raw.querySelectorAll('li'))
      .map(function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); })
      .filter(function (t) { return t.length > 0; });

    /* 5 点描述：变体下方 bullet 列表 */
    if (bullets && items.length) {
      items.forEach(function (text) {
        var parts = splitText(text);
        var li = document.createElement('li');
        var check = document.createElement('span');
        check.className = 'pdp-bullet-check';
        check.innerHTML = ICONS.check;
        var body = document.createElement('div');
        body.className = 'pdp-bullet-body';
        var strong = document.createElement('strong');
        strong.textContent = parts[0];
        body.appendChild(strong);
        if (parts[1]) {
          var span = document.createElement('span');
          span.textContent = parts[1];
          body.appendChild(span);
        }
        li.appendChild(check);
        li.appendChild(body);
        bullets.appendChild(li);
      });
    }

    /* 特性卡片：图标卡片 */
    if (grid && items.length) {
      items.forEach(function (text) {
        var parts = splitText(text);
        var card = document.createElement('div');
        card.className = 'feat-card';
        var icon = document.createElement('div');
        icon.className = 'feat-icon';
        icon.innerHTML = pickIcon(text);
        var h = document.createElement('h3');
        h.textContent = parts[0];
        card.appendChild(icon);
        card.appendChild(h);
        if (parts[1]) {
          var p = document.createElement('p');
          p.textContent = parts[1];
          card.appendChild(p);
        }
        grid.appendChild(card);
      });
    }

    raw.remove();
  }
})();


/* 底部固定下单按钮：点击触发商品表单提交（含当前变体与数量） */
(function () {
  var sticky = document.getElementById('pdpStickyAtc');
  var form = document.getElementById('pdpForm');
  if (!sticky || !form) return;
  sticky.addEventListener('click', function () {
    if (sticky.disabled) return;
    form.submit();
  });
})();

/* 导航下拉：点击切换（移动端/触屏）；点击外部关闭 */
(function () {
  var toggle = document.querySelector('.nav-dropdown-toggle');
  var dropdown = document.querySelector('.nav-dropdown');
  if (!toggle || !dropdown) return;
  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    dropdown.classList.toggle('open');
  });
  document.addEventListener('click', function (e) {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });
})();

/* 评论区品牌化重构（对齐 prototype 的 Loox 风格）：
   1) 摘要 → 大数字评分 + 5 星 + "N reviews"；
   2) 柱状图 → "5★ / 进度条 / 百分比"；
   3) 评论卡片 → 原型 .t-card（星级在上、正文居中、头像+用户名+Verified buyer 在下）。 */
(function () {
  function cleanName(s) {
    return s.replace(/[\u274c\uFE0F]/g, '').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function transformSummary(root) {
    var summary = root.querySelector('.jdgm-rev-widg__summary');
    if (!summary) return;
    var starsEl = summary.querySelector('.jdgm-rev-widg__summary-stars');
    var avgEl = summary.querySelector('.jdgm-rev-widg__summary-average');
    var textEl = summary.querySelector('.jdgm-rev-widg__summary-text');
    if (!starsEl || !avgEl) return;
    var m = (avgEl.textContent || '').match(/(\d+(?:\.\d+)?)/);
    if (!m || m[1] === '0') return;
    var num = m[1];
    var existing = summary.querySelector('.jdgm-avg-big');
    if (existing && existing.textContent === num) return;
    var count = '';
    if (textEl) {
      var cm = (textEl.textContent || '').match(/(\d[\d,]*)/);
      count = cm ? cm[1] : '';
    }
    var starNodes = Array.prototype.slice.call(starsEl.querySelectorAll('.jdgm-star'));
    starsEl.innerHTML = '';
    starsEl.classList.add('jdgm-score');
    var big = document.createElement('div');
    big.className = 'jdgm-avg-big';
    big.textContent = num;
    starsEl.appendChild(big);
    var starRow = document.createElement('div');
    starRow.className = 'jdgm-avg-stars';
    starNodes.forEach(function (s) { starRow.appendChild(s); });
    starsEl.appendChild(starRow);
    if (textEl && count) {
      textEl.textContent = count + ' reviews';
    }
  }
  function transformHistogram(root) {
    var rows = root.querySelectorAll('.jdgm-histogram__row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var rating = row.getAttribute('data-rating');
      if (rating == null || rating === 'null') {
        row.style.setProperty('display', 'none', 'important');
        continue;
      }
      var freq = row.getAttribute('data-frequency');
      var starEl = row.querySelector('.jdgm-histogram__star');
      var freqEl = row.querySelector('.jdgm-histogram__frequency');
      if (starEl) {
        starEl.textContent = rating + '★';
        starEl.classList.add('jdgm-bar-label');
      }
      if (freqEl && freq != null) {
        freqEl.textContent = freq;
      }
    }
  }
  function rebuildCards(root) {
    var revs = root.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < revs.length; i++) {
      var rev = revs[i];
      if (rev.getAttribute('data-themed') === '1') continue;
      var ratingEl = rev.querySelector('.jdgm-rev__rating');
      var score = 0;
      if (ratingEl) {
        score = parseInt(ratingEl.getAttribute('data-score') || '0', 10);
        if (!score) score = ratingEl.querySelectorAll('.jdgm-star.jdgm--on').length;
      }
      if (!score) score = 5;
      var bodyEl = rev.querySelector('.jdgm-rev__body');
      var body = bodyEl ? (bodyEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
      var authorEl = rev.querySelector('.jdgm-rev__author');
      var author = authorEl ? cleanName(authorEl.textContent || '') : '';
      if (!author) author = 'Verified buyer';
      var iconEl = rev.querySelector('.jdgm-rev__icon');
      var initial = iconEl ? cleanName(iconEl.textContent || '') : '';
      if (!initial) initial = author.charAt(0).toUpperCase();
      var dateEl = rev.querySelector('.jdgm-rev__timestamp');
      var date = dateEl ? (dateEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
      var stars = '';
      for (var s = 0; s < 5; s++) stars += (s < score ? '★' : '☆');
      rev.classList.add('t-card');
      rev.innerHTML =
        '<div class="stars-row">' +
          '<span class="stars">' + stars + '</span>' +
          (date ? '<span class="date">' + esc(date) + '</span>' : '') +
        '</div>' +
        '<p>' + esc(body) + '</p>' +
        '<div class="who">' +
          '<span class="avatar">' + esc(initial) + '</span>' +
          '<b>' + esc(author) + '</b>' +
          '<span class="verified" title="Verified buyer">&#10003;</span>' +
          '<span class="platform">TikTok</span>' +
        '</div>';
      rev.setAttribute('data-themed', '1');
    }
  }
  function fix() {
    var root = document.getElementById('judgeme_product_reviews');
    if (root) {
      transformSummary(root);
      transformHistogram(root);
      rebuildCards(root);
    }
  }
  function run() {
    try { fix(); } catch (e) {}
  }
  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1500);
  setTimeout(run, 3000);
  setTimeout(run, 5500);
  setTimeout(run, 9000);
  var root = document.getElementById('judgeme_product_reviews');
  if (root && typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(schedule);
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }
})();
